import { IProgramType } from 'legacy/lut/features/partner360/configuration'

export const getOfferingsInfo = (availableProgramTypes: IProgramType[]) => {
  const currentOfferings = availableProgramTypes.filter((it) => !it.isDeprecated)
  const enabledOfferings = currentOfferings.filter((it) => it.enabled)
  const oldOfferings = availableProgramTypes.filter((it) => it.isDeprecated)
  return { currentOfferings, enabledOfferings, oldOfferings }
}
